import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { getCopy } from 'utils/copy';
import s from 'components/shared/theaters/ticketing/gateways/paymentLoader.sss';


export default class PaymentLoader extends Component {

	constructor(props) {
		super(props);

		this.width = 400;
		this.height = 10;
		this.duration = 2500;
		this.numDots = 5;
		this.keyframes = [
			[0, 0, 0],
			[0.22, 0.4, 1],
			[0.58, 0.6, 1],
			[0.8, 1, 0],
			[1, 1, 0]
		];

		this.frame = null;

		this.defaultText = getCopy('LOADING_SECURE_PAYMENTS') + '...';

		this.updateLoader = this.updateLoader.bind(this);
	}

	componentDidMount() {
		this.$canvas.width = this.width;
		this.$canvas.height = this.height;

		this.ctx = this.$canvas.getContext('2d');
		this.ctx.fillStyle = this.props.color || '#000';

		this.frame = requestAnimationFrame(this.updateLoader);
	}

	componentWillUnmount() {
		if (this.frame) {
			cancelAnimationFrame(this.frame);
		}
	}

	updateLoader(time) {
		this.frame = requestAnimationFrame(this.updateLoader);

		this.ctx.clearRect(0, 0, this.width, this.height);
		for (let i = 0; i < this.numDots; i++) {
			let t = Math.max(time - i * 200, 0) / this.duration;
			t -= Math.floor(t);

			let position;
			let opacity;
			if (t <= this.keyframes[0][0]) {
				[, position, opacity] = this.keyframes[0];
			} else if (t >= this.keyframes[this.keyframes.length - 1][0]) {
				[, position, opacity] = this.keyframes[this.keyframes.length - 1];
			} else {
				let j;
				for (j = 1; j < this.keyframes.length && this.keyframes[j][0] < t; j++);
				const [t0, p0, o0] = this.keyframes[j - 1];
				const [t1, p1, o1] = this.keyframes[j];
				const k = (t - t0) / (t1 - t0);
				position = (p0 + (p1 - p0) * k) * this.width;
				opacity = o0 + (o1 - o0) * k;
			}

			this.ctx.beginPath();
			this.ctx.fillStyle = this.props.textColor || '#000';
			this.ctx.globalAlpha = opacity;
			this.ctx.arc(position, this.height / 2, this.height / 2, 0.0, 2 * Math.PI);
			this.ctx.fill();
		}
	}

	render(props) {
		const {
			children,
			color = '#000',
			bgColor = '#fff',
			textColor = '#000',
			logoHeight,
			text
		} = props;

		const displayedText = typeof text === 'string' && text.length > 0 ? text : this.defaultText;

		const style = {
			backgroundColor: bgColor,
			...props.style
		};

		const logoStyle = { color };
		if (logoHeight) {
			logoStyle.height = logoHeight;
		}

		return (
			<div class={joinClasses(s.loaderWrapper, props.class)} style={style}>
				<div class={s.logo} style={logoStyle}>
					{children}
				</div>
				<canvas class={s.loader} ref={$ref => this.$canvas = $ref} />
				<p class={s.status} style={{ color: textColor }}>{displayedText}</p>
			</div>
		);
	}

}
